var getIsIE = function getIsIE() {
  return !!(document && document.documentMode);
};

export { getIsIE };
